// @mui material components
import Grid from "@mui/material/Grid";
import PropTypes from "prop-types";

import FormField from "../../../layouts/ecommerce/products/new-product/components/FormField";

// Material Dashboard 2 PRO React components
import MDBox from "../../../components/MDBox";

export default function PlannedInfos({ deviceId, hoursPlanned, setHoursPlanned }) {
  return (
    <MDBox>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormField
            inputProps={{ maxLength: 255 }}
            value={hoursPlanned}
            onChange={(event) => setHoursPlanned(event.target.value)}
            required
            variant="standard"
            type="number"
            label="Nombre d'heures planifiées"
          />
        </Grid>
      </Grid>
    </MDBox>
  );
}

/* CostingInfos.propTypes = {
  price: PropTypes.number,
  setPrice: PropTypes.func.isRequired,
  purchases: PropTypes.number,
  setPurchases: PropTypes.func.isRequired,
  hoursSold: PropTypes.number,
  setHoursSold: PropTypes.func.isRequired,
  prorataAccount: PropTypes.number,
  setProrataAccount: PropTypes.func.isRequired,
}; */
